import api from './api';

export interface CompanyWallet {
  id: number;
  company_id: number;
  wallet_id: number;
  comment?: string;
  created_at: string;
  wallet?: {
    id: number;
    name: string;
    wallet_type: 'CRYPTO' | 'BANK';
    active: boolean;
    crypto_currency?: string;
    wallet_address?: string;
    bank_details?: string;
  };
}

export interface CompanyWalletCreate {
  company_id: number;
  wallet_id: number;
  comment?: string;
}

export interface CompanyWalletUpdate {
  comment?: string;
}

export const companyWalletsApi = {
  // Create company wallet
  createCompanyWallet: async (companyWallet: CompanyWalletCreate): Promise<CompanyWallet> => {
    const response = await api.post('/api/company-wallets', companyWallet);
    return response.data;
  },

  // Get company wallets with details
  getCompanyWallets: async (companyId: number): Promise<CompanyWallet[]> => {
    const response = await api.get(`/api/company-wallets/company/${companyId}/wallets`);
    return response.data;
  },

  // Get company wallet by ID
  getCompanyWallet: async (companyWalletId: number): Promise<CompanyWallet> => {
    const response = await api.get(`/api/company-wallets/${companyWalletId}`);
    return response.data;
  },

  // Update company wallet
  updateCompanyWallet: async (companyWalletId: number, companyWallet: CompanyWalletUpdate): Promise<CompanyWallet> => {
    const response = await api.put(`/api/company-wallets/${companyWalletId}`, companyWallet);
    return response.data;
  },

  // Delete company wallet
  deleteCompanyWallet: async (companyWalletId: number): Promise<void> => {
    await api.delete(`/api/company-wallets/${companyWalletId}`);
  }
};




















